// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import SlideVerify from '../node_modules/vue-monoplasty-slide-verify'
import axios from 'axios'
import global from '@/utils/global'

Vue.prototype.$config = configJson;
if(process.env.NODE_ENV=="production"){
	axios.defaults.baseURL = configJson.appBaseUrl;
}else{
	axios.defaults.baseURL = "/susapi";
}
axios.defaults.timeout = 10000;
Vue.prototype.$axios = axios

Vue.config.productionTip = false
Vue.use(elementUi)
Vue.use(SlideVerify)
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js